import { progressAnatomy as parts } from '@chakra-ui/anatomy'
import { generateStripe, mode } from '@chakra-ui/theme-tools'

function filledStyle(props) {
  const { isIndeterminate, hasStripe } = props

  const stripeStyle = mode(generateStripe(), generateStripe('1rem', 'rgba(0,0,0,0.1)'))(props)

  const gradient = `linear-gradient(
    to right,
    transparent 0%,
    var(--main) 50%,
    transparent 100%
  )`

  const addStripe = !isIndeterminate && hasStripe

  return {
    ...(addStripe && stripeStyle),
    ...(isIndeterminate ? { bgImage: gradient } : { bgColor: 'var(--main)' })
  }
}

const baseStyleFilledTrack = props => {
  return {
    transitionProperty: 'common',
    transitionDuration: 'slow',
    ...filledStyle(props)
  }
}

const baseStyle = props => ({
  label: {
    lineHeight: '1',
    fontSize: '0.25em',
    fontWeight: 'bold',
    color: 'white'
  },
  filledTrack: baseStyleFilledTrack(props),
  track: {
    bg: 'brand.hover'
  }
})

const sizes = {
  xs: {
    track: { h: '0.25rem' }
  },
  sm: {
    track: { h: '0.5rem' }
  },
  md: {
    track: { h: '0.75rem' }
  },
  lg: {
    track: { h: '1rem' }
  }
}

export const Progress = {
  parts: parts.keys,
  sizes,
  baseStyle,
  defaultProps: {
    size: 'md'
  }
}
